import _ from 'lodash';
import envVar from '../../config/envVars';
import httpGet from '../httpClient/httpGet';
import httpPost from '../httpClient/httpPost';
import httpDelete from '../httpClient/httpDelete';
import httpPut from '../httpClient/httpPut';
import { Stop, StopDetailedView } from '../../modules/RoutesManagement/types';

export type GetStopsResponse = Stop[] | StopDetailedView[];

export const getStops = async (
  school: string,
  routeId?: string,
  fetchDetailedView?: boolean
) => {
  const params = new URLSearchParams();
  if (school) {
    params.append('school', school);
  }
  if (routeId) {
    params.append('routeId', routeId);
  }
  if (fetchDetailedView) {
    params.append('fetchDetailedView', 'true');
  }
  return httpGet(
    `${envVar.REACT_APP_BUS_TRACKING_API_BASE_URL}/stops?${params.toString()}`,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_BUS_TRACKING_API_TOKEN}`
      }
    }
  );
};

export interface AddStopRequest {
  name: string;
  location: { lat: string; long: string };
  triggerStop?: string;
  addStopAfter?: string;
  isFirstStop?: boolean;
  travelTime: string;
  offsetLocation?: { lat: string; long: string };
}

export interface UpdateStopRequest
  extends Omit<AddStopRequest, 'addStopAfter' | 'isFirstStop'> {}

export const updateStop = async (
  stopId: string,
  stopData: Partial<UpdateStopRequest>
) => {
  return httpPut(
    `${envVar.REACT_APP_BUS_TRACKING_API_BASE_URL}/stops/${stopId}`,
    _.omitBy(stopData, _.isUndefined),
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_BUS_TRACKING_API_TOKEN}`,
        'Content-Type': 'application/json'
      }
    }
  );
};

export const addStop = async (
  routeId: string,
  stopData: Partial<AddStopRequest>
) => {
  return httpPost(
    `${envVar.REACT_APP_BUS_TRACKING_API_BASE_URL}/routes/${routeId}/stops`,
    _.omitBy(stopData, _.isUndefined),
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_BUS_TRACKING_API_TOKEN}`,
        'Content-Type': 'application/json'
      }
    }
  );
};

export const deleteStop = async (routeId: string, stopId: string) => {
  return httpDelete(
    `${envVar.REACT_APP_BUS_TRACKING_API_BASE_URL}/routes/${routeId}/stops/${stopId}`,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_BUS_TRACKING_API_TOKEN}`
      }
    }
  );
};

export const assignStudentsToStop = async (
  stopId: string,
  studentIds: string[]
) => {
  return httpPost(
    `${envVar.REACT_APP_BUS_TRACKING_API_BASE_URL}/stops/${stopId}/students`,
    { studentIds },
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_BUS_TRACKING_API_TOKEN}`,
        'Content-Type': 'application/json'
      }
    }
  );
};
